"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
var Fields = {
    name: 'name',
    email: 'email',
    role: ['role_user.role_id', 'name'],
};
function ListHeader(_a) {
    var sortField = _a.sortField, onSort = _a.onSort;
    function getActiveClass(fields) {
        var field = Array.isArray(fields) ? fields[0] : fields;
        return "cursor-pointer " + (sortField === field ? 'font-medium underline' : '');
    }
    return react_1.default.createElement("dt", { className: 'flex storybook-lists-item-row py-1.5 px-3.5 sm:px-7' },
        react_1.default.createElement("div", { className: 'w-1/3', onClick: function () { return onSort(Fields.name); } },
            react_1.default.createElement(storybook_1.Texts.Secondary, { appendClassname: getActiveClass(Fields.name) }, "Naam")),
        react_1.default.createElement("div", { className: 'w-1/2 md:w-1/3', onClick: function () { return onSort(Fields.email); } },
            react_1.default.createElement(storybook_1.Texts.Secondary, { appendClassname: getActiveClass(Fields.email) }, "E-mailadres")),
        react_1.default.createElement("div", { className: 'w-1/6 md:w-1/3 flex items-center' },
            react_1.default.createElement("div", { className: 'mr-1', onClick: function () { return onSort(Fields.role); } },
                react_1.default.createElement(storybook_1.Texts.Secondary, { appendClassname: getActiveClass(Fields.role) }, "Rol")),
            react_1.default.createElement(storybook_1.Buttons.Link, { to: 'https://eyecons.zendesk.com/hc/nl/articles/10140234472977-Welke-gebruikersrollen-zijn-er-op-Eyecons-', target: '_blank' },
                react_1.default.createElement(storybook_1.Icons.Icon, { name: 'info', className: 'storybook-icons-icon text-disabled' }))),
        react_1.default.createElement("div", { className: 'mr-9 sm:mr-16 md:mr-13' }));
}
exports.default = ListHeader;
ListHeader.propTypes = {};
ListHeader.defaultProps = {};
